import {
  Box,
  TextField,
  IconButton,
  TableCell,
  TableRow,
  FormControl,
  FormHelperText,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';

const RecipientTableRow = ({
  recipient,
  isEditing,
  editValue,
  editError,
  onStartEdit,
  onSaveEdit,
  onCancelEdit,
  onDelete,
  onEditChange,
}) => {
  return (
    <TableRow hover>
      <TableCell>
        {isEditing ? (
          <FormControl fullWidth error={!!editError}>
            <TextField
              fullWidth
              value={editValue}
              onChange={onEditChange}
              size="small"
              autoFocus
              error={!!editError}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  onSaveEdit();
                } else if (e.key === 'Escape') {
                  onCancelEdit();
                }
              }}
            />
            {editError && <FormHelperText>{editError}</FormHelperText>}
          </FormControl>
        ) : (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {recipient.recipientEmail}
          </Box>
        )}
      </TableCell>
      <TableCell align="right">
        {isEditing ? (
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
            <IconButton size="small" color="primary" onClick={onSaveEdit}>
              <SaveIcon />
            </IconButton>
            <IconButton size="small" onClick={onCancelEdit}>
              <CancelIcon />
            </IconButton>
          </Box>
        ) : (
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
            <IconButton size="small" color="primary" onClick={onStartEdit}>
              <EditIcon />
            </IconButton>
            <IconButton size="small" color="error" onClick={onDelete}>
              <DeleteIcon />
            </IconButton>
          </Box>
        )}
      </TableCell>
    </TableRow>
  );
};

export default RecipientTableRow;
